// Captures the referral id from the URL once, as early as possible, so it
// survives the wallet-connect round trip (some in-app browsers re-navigate).
// We keep it in module memory AND sessionStorage (allowed in real browsers;
// this is the app shell, not a sandboxed artifact).

let cached = null;

function readFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref && /^[0-9]+$/.test(ref)) return ref;
  } catch (_) {}
  return null;
}

export function captureRef() {
  if (cached) return cached;
  const fromUrl = readFromUrl();
  if (fromUrl) {
    cached = fromUrl;
    try { sessionStorage.setItem('zen_ref', fromUrl); } catch (_) {}
    return cached;
  }
  try {
    const saved = sessionStorage.getItem('zen_ref');
    if (saved && /^[0-9]+$/.test(saved)) { cached = saved; return cached; }
  } catch (_) {}
  return null;
}

export function getRef() {
  return cached || captureRef();
}

export function clearRef() {
  cached = null;
  try { sessionStorage.removeItem('zen_ref'); } catch (_) {}
}
